module.exports = __webpack_public_path__ + "img/logoCMF.02f1061e.png";